import { authStorage } from '../services/authStorage';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { userPreferencesApi } from '../services/api';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'sv' ? 'en' : 'sv';
    i18n.changeLanguage(newLang);
    // This storage is created only after the visitor requests a language and is
    // needed to remember that explicit preference on the next page load.
    localStorage.setItem('i18nextLng', newLang);
    // Persist to the server only when authenticated. On public pages (login,
    // register, forgot-password) there is no user, so this request 401s and the
    // response interceptor redirects to /login — a full reload that throws the
    // language change away. The choice still survives via the localStorage
    // language detector (see src/i18n/index.ts).
    if (authStorage.getItem('accessToken')) {
      userPreferencesApi.savePreference('language', newLang).catch(error => {
        console.error('Failed to save language preference:', error);
      });
    }
  };

  const flagSrc = i18n.language === 'sv'
    ? '/assets/vendors/img/flags/4x3/se.svg'
    : '/assets/vendors/img/flags/4x3/gb.svg';

  return (
    <button
      className="btn btn-light-brand d-flex align-items-center gap-2"
      onClick={toggleLanguage}
      title={i18n.language === 'sv' ? 'Switch to English' : 'Byt till svenska'}
    >
      <img
        src={flagSrc}
        alt={i18n.language === 'sv' ? 'Svenska' : 'English'}
        style={{ width: '20px', height: '15px' }}
      />
      <span className="text-uppercase fw-bold">{i18n.language}</span>
    </button>
  );
}
